'use strict';

module.exports = function () {
	$('body').each(function () {



		function centerPopUp(namePopUp) {
			let scrollTop 	 = $(window).scrollTop();
			let	heightWindow = $(window).height();
			let	heightPopUp	 = $(namePopUp).outerHeight();
			let	total		 = scrollTop + ((heightWindow - heightPopUp) / 2);

			if (heightPopUp > heightWindow) {
				$(namePopUp).css({'top': scrollTop + ((heightWindow * 10 / 100))});
			} else {
				$(namePopUp).css({'top': total});
			}
		}



		$('.jsPopUp').on('DOMNodeInserted', function () {
			centerPopUp($(this));
		});



		$(document).ready(function () {
			if (!($('.overlay').length)) {
				$("body").append("<div class=\"overlay\">");
			}
		});



		$(document).keydown(function (e) {
			if( e.keyCode === 27 ) {
				$(".overlay, .jsPopUp").hide();
			}
		});



		$(document).delegate(".overlay, .jsPopUpClose", "click", function (e) {
			e.preventDefault();

			$(".overlay, .jsPopUp").hide();
		});



		$("a[href^=\"#pop-up\"]").on("click", function (e) {
			e.preventDefault();

			let namePopUp = $(this).attr("href");

			centerPopUp(namePopUp);
			centerPopUp(".jsPopUpCallbackSubmitted");

			$(".overlay, "+ namePopUp +"").show();
		});



		//
		// Записываем куку и показываем pop-up с предупреждением
		//

		/*$(document).on('ready', function() {{
			if(!($.cookie("notification") == "true")) {
				$.cookie("notification", "true", {
					expires: 0,
					path: "/"
				});

				centerPopUp('#pop-up-notification');
				$(".overlay, .jsPopUpNotification").show();
			}
		}});*/



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/popUpInit.js
 **/